import { useContext } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from 'src/contexts/AuthContext';
import { handleLogout } from 'src/helpers/helpers';

export const useAccessDeniedViewController = () => {
  const authContext = useContext(AuthContext);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const navigateToLogin = () => {
    handleLogout(authContext, dispatch);
    navigate('/login');
  };

  return {
    navigateToLogin,
  };
};
